import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const TICKET_TYPE = ['noBarCode', 'eTicket', 'ticket']
const WAIT_LIST = ['noWaitList', 'enterWaitList']
const PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount']

export const schema = Joi.object().keys({
	title: Joi.string().allow(''),
	index: Joi.number().integer().allow(''),
	ticket_type: Joi.string().valid(TICKET_TYPE).allow(''),
  amount: Joi.number().integer().allow(''),
  auto_wait_list: Joi.string().valid(WAIT_LIST).allow(''),
  start_at: Joi.string().allow(null).allow(''),
  end_at: Joi.string().allow(null).allow(''),
  max_per_order:  Joi.number().integer().allow(''),
  price_type: Joi.string().valid(PRICE_TYPE).allow(''),
  price: Joi.number().integer().allow(''),
  tax_percent: Joi.number().integer().allow(''),
});

export default function createTicket(posterId, ticketInfo) {

  if(!posterId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing poster ID')
      })
    })
  }

  let validateResult = Joi.validate(ticketInfo, schema);
  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	let toServer = {
		...ticketInfo,
		ticket_type: ticketInfo.ticket_type ? TICKET_TYPE.indexOf(ticketInfo.ticket_type) : 0,
		auto_wait_list: ticketInfo.auto_wait_list ? WAIT_LIST.indexOf(ticketInfo.auto_wait_list) : 1,
		price_type: ticketInfo.price_type ? PRICE_TYPE.indexOf(ticketInfo.price_type) : 0,
	}

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/poster_ticket_list/${posterId}/`,
    'method': 'POST',
    'data': JSON.stringify(toServer),
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data)
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/ticket/createTicket.js